<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form @keyup.enter.native="searchQuery" layout="inline">
        <a-row :gutter="24">
          <a-col :lg="5" :md="5" :sm="24" :xl="5" v-if=" userInfo.thirdAccount ">
            <a-form-item label="班组">
              <j-search-select-tag
                :dictOptions="consGroupOptions"
                @change="searchQuery"
                placeholder="请选择班组"
                v-model="queryParam.groupId"
              />
            </a-form-item>
          </a-col>

          <a-col :lg="7" :md="8" :sm="24" :xl="6">
            <a-form-item label="姓名">
              <a-input placeholder="请输入姓名" v-debounce="searchQuery" v-model="queryParam.nickname"></a-input>
            </a-form-item>
          </a-col>
          <a-col :lg="7" :md="8" :sm="24" :xl="6">
            <a-form-item label="手机号">
              <a-input placeholder="请输入手机号" v-debounce="searchQuery" v-model="queryParam.phone"></a-input>
            </a-form-item>
          </a-col>
          <a-col
            :lg="7"
            :md="8"
            :sm="24"
            :xl="6"
            v-if=" !userInfo.thirdAccount && !hiddenQueryItems.includes('corpId')"
          >
            <a-form-item label="所属企业">
              <j-dict-select-tag
                @change="searchQuery"
                dictCode="`iwt-wf`.wf_consumer_corp,corp_name,id"
                placeholder="请选择所属企业"
                v-model="queryParam.corpId"
              />
            </a-form-item>
          </a-col>
          <a-col :lg="7" :md="8" :sm="24" :xl="6">
            <span class="table-page-search-submitButtons" style="float: left;overflow: hidden;">
              <a-button @click="searchQuery" icon="search" type="primary">查询</a-button>
              <a-button @click="searchReset" icon="reload" style="margin-left: 8px" type="primary">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" icon="plus" type="primary" v-if="!disabled">新增</a-button>
      <a-button @click="handleExportXls('用户端账号')" icon="download" type="primary">导出</a-button>
      <a-upload
        :action="importExcelUrl"
        :headers="tokenHeader"
        :multiple="false"
        :showUploadList="false"
        @change="handleImportExcel"
        name="file"
        v-if="!disabled"
      >
        <a-button icon="import" type="primary">导入</a-button>
      </a-upload>
      <!-- 高级查询区域 -->
      <j-super-query :fieldList="superFieldList" @handleSuperQuery="handleSuperQuery" ref="superQueryModal"></j-super-query>
      <a-dropdown v-if="selectedRowKeys.length > 0 && !userInfo.thirdAccount && !disabled">
        <a-menu slot="overlay">
          <a-menu-item @click="batchDel" key="1">
            <a-icon type="delete" />删除
          </a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px">
          批量操作
          <a-icon type="down" />
        </a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a @click="onClearSelected" style="margin-left: 24px">清空</a>
      </div>

      <a-table
        :columns="columns"
        :dataSource="dataSource"
        :loading="loading"
        :pagination="ipagination"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        :scroll="{x:true}"
        @change="handleTableChange"
        bordered
        class="j-table-force-nowrap"
        ref="table"
        rowKey="id"
        size="middle"
      >
        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span style="font-size: 12px;font-style: italic;" v-if="!text">无图片</span>
          <img
            :src="getImgView(text)"
            alt
            height="25px"
            style="max-width:80px;font-size: 12px;font-style: italic;"
            v-else
          />
        </template>
        <span slot="statusSlot" slot-scope="text, record">
          <a-tag color="#52c41a" v-if="record.userStatus == '1'">{{record.userStatus_dictText}}</a-tag>
          <a-tag color="#ff4d4f" v-else>{{record.userStatus_dictText}}</a-tag>
        </span>

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)" v-if="!disabled">编辑</a>
          <a-divider type="vertical" v-if="!disabled" />
        
            <!-- 项目管理员可以调离人员到别的企业 -->
          <template v-if=" !userInfo.thirdAccount ">
            <a @click="exchangeCorp(record)" v-if="!disabled">调换企业</a>
            <a-divider type="vertical" v-if="!disabled" />
          </template>

          <a-dropdown v-if="!disabled">
            <a class="ant-dropdown-link">
              更多
              <a-icon type="down" />
            </a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleDetail(record)">详情</a>
              </a-menu-item>
              <a-menu-item>
                <a @click="handleChangePassword(record)">重置密码</a>
              </a-menu-item>
              <a-menu-item v-if=" !userInfo.thirdAccount && record.userStatus != '1' ">
                <a @click="handleChangeUserStatus(record.id, 1)">恢复</a>
              </a-menu-item>
              <a-menu-item v-if="record.userStatus != '2' ">
                <a-popconfirm @confirm="() => handleChangeUserStatus(record.id, 2)" title="确定冻结吗？冻结后此账号不可登录。">
                  <a>冻结</a>
                </a-popconfirm>
              </a-menu-item>
              <a-menu-item v-if="record.userStatus != '3' ">
                <a-popconfirm @confirm="() => handleChangeUserStatus(record.id, 3)" title="确定停用吗？停用后此账号不可连接加水机取水。">
                  <a>停用</a>
                </a-popconfirm>
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm @confirm="() => handleDelete(record.id)" title="确定删除吗?">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>

          <a @click="handleDetail(record)" v-if="disabled">详情</a>
        </span>
      </a-table>
    </div>

    <wf-consumer-user-modal @ok="modalFormOk" ref="modalForm"></wf-consumer-user-modal>

    <password-modal ref="passwordmodal"></password-modal>

    <exchange-corp-modal ref="exchangeCorpModal" @ok="modalFormOk"></exchange-corp-modal>
  </a-card>
</template>

<script>
  import { getAction, putAction } from '@/api/manage'
  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import WfConsumerUserModal from './modules/WfConsumerUserModal'
  import PasswordModal from './modules/PasswordModal'
  import ExchangeCorpModal from './modules/ExchangeCorpModal.vue'
  import { filterMultiDictText } from '@/components/dict/JDictSelectUtil'

  export default {
    name: 'WfConsumerUserList',
    mixins: [JeecgListMixin, mixinDevice],
    components: {
      WfConsumerUserModal,
      PasswordModal,
      ExchangeCorpModal,
    },
    props: {
      //编辑禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      },
      //表单禁用
      filter: {
        type: Object,
        default: () => { },
      }
    },
    watch: {
      filter: {
        handler (newFilter) {
          this.searchQuery();
        },
        deep: true
      }
    },
    data () {
      return {
        description: '用户端账号管理页面',
        ipagination: {
          pageSize: 30,
        },
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key: 'rowIndex',
            width: 60,
            align: "center",
            customRender: function (t, r, index) {
              return parseInt(index) + 1;
            }
          },
          {
            title: '登录账号',
            align: "center",
            sorter: true,
            dataIndex: 'username'
          },
          {
            title: '姓名',
            align: "center",
            sorter: true,
            dataIndex: 'nickname'
          },
          {
            title: '头像',
            align: "center",
            dataIndex: 'avatar',
            scopedSlots: { customRender: 'imgSlot' }
          },
          {
            title: '手机号',
            align: "center",
            sorter: true,
            dataIndex: 'phone'
          },
          {
            title: '所属企业',
            align: "center",
            sorter: true,
            dataIndex: 'corpId_dictText'
          },
          {
            title: '班组',
            align: "center",
            sorter: true,
            dataIndex: 'groupId_dictText'
          },
          //   {
          //     title: '是否禁用',
          //     align: "center",
          //     dataIndex: 'disabled',
          //     customRender: (text) => (text ? filterMultiDictText(this.dictOptions['disabled'], text) : ''),
          //   },
          {
            title: '用户状态',
            align: "center",
            sorter: true,
            dataIndex: 'userStatus_dictText',
            scopedSlots: { customRender: 'statusSlot' }
          },
          {
            title: '操作',
            dataIndex: 'action',
            align: "center",
            fixed: "right",
            width: 147,
            scopedSlots: { customRender: 'action' }
          }
        ],
        url: {
          list: "/custom/user/list",
          edit: "/custom/user/edit",
          delete: "/custom/user/delete",
          deleteBatch: "/custom/user/deleteBatch",
          exportXlsUrl: "/custom/user/exportXls",
          importExcelUrl: "custom/user/importExcel",
          corpGroupList: 'wf/corpGroup/list',
        },
        localFilter: {},
        dictOptions: {},
        consGroupOptions: [],
        superFieldList: [],
        disableMixinCreated: true,
      }
    },
    created () {
      this.$set(this.dictOptions, 'disabled', [{ text: '是', value: 'Y' }, { text: '否', value: 'N' }])
      this.getSuperFieldList();

      //如果是企业管理员登录，赋值corpId, 值为userInfo.corpIds
      if (!!this.userInfo.thirdAccount) {
        this.localFilter = {
          corpId: this.userInfo.corpIds
        }
      }

      if (this.filter?.corpId || this.localFilter?.corpId) {
        this.columns = this.columns.filter(col => col.dataIndex !== 'corpId_dictText')
        //写入queryParam，查询和导出都增加过滤条件
        this.queryParam.corpId = this.filter?.corpId || this.localFilter?.corpId;
      }

      // 在 localFilter 设置完成后调用 loadData
      this.$nextTick(() => {
        this.loadData(1);

        this.getConsGroup();
      });
    },
    computed: {
      importExcelUrl () {
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
      hiddenQueryItems () {
        return this.filter ? Object.keys(this.filter) : [];
      },
      userInfo () {
        return this.$store.getters.userInfo
      }
    },
    methods: {
      handleChangePassword (record) {
        this.$refs.passwordmodal.show(record);
      },
      exchangeCorp(record){
        this.$refs.exchangeCorpModal.show(record);
      },
      handleChangeUserStatus (id, status) {
        putAction(this.url.edit, { id: id, userStatus: status })
          .then(res => {
            if (res.success) {
              this.$emit('ok')
              this.loadData()
            } else {
              that.$message.warning(res.message)
            }
          }).finally(() => {
            this.confirmLoading = false
          })
      },
      //因为查询条件重置功能会清空queryParam，所以需要重写loadData方法，把固定的查询条件加进去
      loadData (arg) {
        if (!this.url.list) {
          this.$message.error('请设置url.list属性!')
          return
        }
        // 加载数据 若传入参数1则加载第一页的内容
        if (arg === 1) {
          this.ipagination.current = 1
        }
        var params = this.getQueryParams()// 查询条件
        this.loading = true;
        // 合并 localFilter 和 filter
        const mergedFilter = { ...this.localFilter, ...this.filter };
        Object.assign(params, mergedFilter);

        console.log('loadData params:', params); // 添加日志以检查参数
        if (params.phone) {
          params.phone = `*${params.phone}*`;
        }
        getAction(this.url.list, params).then((res) => {
          if (res.success) {
            this.dataSource = res.result.records || res.result
            if (res.result.total) {
              this.ipagination.total = res.result.total
            } else {
              this.ipagination.total = 0
            }
          }
        }).finally(() => {
          this.loading = false
        })
      },
      handleAdd () {
        const model = {};
        if (this.filter?.corpId || this.localFilter?.corpId) {
          //写入queryParam，查询和导出都增加过滤条件
          model.corpId = this.filter?.corpId || this.localFilter?.corpId;
        }
        this.$refs.modalForm.add(model)
        this.$refs.modalForm.title = `新增`
        this.$refs.modalForm.disableSubmit = false
      },
      getConsGroup () {
        if (!this.userInfo.thirdAccount) {
          return;
        }
        this.consGroupOptions = [];
        const params = {
          pageSize: 999999,
          corpId: this.queryParam.corpId,
          column: 'groupName',
          order: 'asc',
        };
        getAction(this.url.corpGroupList, params).then((res) => {
          if (res.success) {
            res.result.records.forEach(group => {
              this.consGroupOptions.push({
                value: group.id,
                text: group.groupName
              });
            });
          } else {
            this.$message.error(res.message)
          }
        })
      },
      initDictConfig () {
      },
      getSuperFieldList () {
        let fieldList = [];
        fieldList.push({ type: 'string', value: 'username', text: '登录账号', dictCode: '' })
        fieldList.push({ type: 'string', value: 'password', text: '密码', dictCode: '' })
        fieldList.push({ type: 'string', value: 'nickname', text: '姓名', dictCode: '' })
        fieldList.push({ type: 'string', value: 'avatar', text: '头像', dictCode: '' })
        fieldList.push({ type: 'string', value: 'phone', text: '手机号', dictCode: '' })
        fieldList.push({ type: 'int', value: 'sex', text: '性别', dictCode: 'sex' })
        fieldList.push({ type: 'date', value: 'birthday', text: '生日' })
        fieldList.push({ type: 'string', value: 'corpId', text: '所属企业', dictCode: 'wf_consumer_corp,corp_name,id' })
        fieldList.push({ type: 'string', value: 'qrcode', text: '二维码', dictCode: '' })
        fieldList.push({ type: 'string', value: 'wechatUserId', text: '微信用户ID', dictCode: '' })
        fieldList.push({ type: 'string', value: 'qqUserId', text: 'QQ用户ID', dictCode: '' })
        fieldList.push({ type: 'string', value: 'alipayUserId', text: '支付宝用户ID', dictCode: '' })
        fieldList.push({ type: 'string', value: 'dingtalkUserId', text: '钉钉用户ID', dictCode: '' })
        fieldList.push({ type: 'switch', value: 'disabled', text: '是否禁用' })
        this.superFieldList = fieldList
      }
    }
  }
</script>
<style scoped>

  @import '~@assets/less/common.less';

</style>